<template>
    <div class="pb-4 relative">
        <div class="wrapper-input"
            :class="[isError ? 'error' : 'active']">

            <input :type="type"
                :id="inputId"
                class="input-data"
                v-model="content"
                :minlength="inputMinLength"
                :maxlength="inputMaxLength"
                @input="onChange()"
                @focus="onFocus(true)"
                @blur="onFocus(false)">
            <label :for="inputId"
                class="title-label"
                :class="[{'transition-label-no-content': !content && !focusText},
                        {'transition-label-content': content || focusText},
                        ]"
            >
            <div v-if="setDataFromCache && setDataFromCache.text != ''">
                <span v-if="isShowNo && (localeCode != 1086) || (isShowName && (localeCode == 2052))">{{ setDataFromCache.text }}</span>  
                    {{inputLbl.name}}
                <span v-if="(isShowNo && (localeCode == 1086) || (isShowName && (localeCode != 2052)))">{{ setDataFromCache.text }}</span>
            </div>
            <div v-else>
                <span v-if="isShowNo && (localeCode != 1086) || (isShowName && (localeCode == 2052))">{{ showType }}</span>  
                    {{inputLbl.name}}
                <span v-if="(isShowNo && (localeCode == 1086) || (isShowName && (localeCode != 2052)))">{{ showType }}</span>
            </div>                
            </label> 
        </div>
        <div class="text-error" v-if="isError">
            {{getErrorMsg}}
        </div>
    </div>
</template>
<script>
// import Vue from 'vue';
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";
import LocaleMixin from '@/mixin/LocaleMixin.js';
/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {Boolean} isTextOnly (optional) Only text.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputText",
    mixins: [LocaleMixin],
    props: {
        // v-model
        value: String,
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        isTextOnly:     { type: Boolean, default: false },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        delimeter:      { type: String, default: '' },
        // text
        inputLbl:       { type: Object, required: true },
        selectType:     { type: String, default:''},
        isShowName:     { type: Boolean, default: false },
        isShowNo:       { type: Boolean, default: false },
        refCode:        { type: String },
        dataFromCache:  { type: Object },
        itemList:       { type: Array, required: false },
    },
    data: function() {
        return {
            inputId: '',
            content: this.value,
            inputMinLength: null,
            inputMaxLength: null,
            focusText: false,
            showType: '',
            type: '',
            refferalCode: '',
            setDataFromCache: null
        };
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
                ? this.errorInfo.msg
                : '';
        },
    },
    created: function () {
        let randId = Math.floor(Math.random() * 100000);
        this.inputId = 'contact-number-' + randId;

        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
        this.setDataFromCache = this.dataFromCache;
        this.checkTypeId();
    },
    mounted: function() {
        this.validateInput();
    },
    watch: {
        selectType: function(newItem){
            if(newItem){
                let item = this.itemList.find((obj) => {
                    return obj.value == newItem;
                });
                this.showType = item.text;
                this.setDataFromCache = null;
                if ((this.setDataFromCache && this.setDataFromCache.text) != this.showType) {
                    if (this.isShowNo) {
                        this.content = '';
                        this.$emit('update:inputValue', this.content);
                    }
                }
                this.checkTypeId();
            }
        },
        refCode: function(ref) {
            if (ref) {
                this.content = ref;
                this.onChange();
            }
        },
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && this.minLength
                && (this.content.length < this.minLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
                return;
            }
            // invalid format
            if (this.inputLbl.invalid && this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.invalid);
                return;
            }
        },
        checkTypeId: function () {
            if ((this.selectType == 'NRIC' || (this.setDataFromCache && this.setDataFromCache.value == 'NRIC')) && this.isShowNo) {
                this.inputMaxLength = 14;
                this.type = 'tel';
            } else if ((this.selectType == 'Passport') || (this.setDataFromCache && this.setDataFromCache.value == 'Passport')
                && this.isShowNo) {
                this.inputMaxLength = 9;
                this.type = 'text';
            } else if ((this.selectType == 'Army ID' || this.selectType == 'Police ID') || 
                    ((this.setDataFromCache && this.setDataFromCache.value == 'Army ID') ||
                    (this.setDataFromCache && this.setDataFromCache.value  == 'Police ID')) && this.isShowNo) {
                this.inputMinLength = 5;
                this.inputMaxLength = 10;
                this.type = 'text';
            }
            if (this.isShowName) {
                this.inputMaxLength = this.maxLength;
            }
        },
        
        onChange: function() {
            var result = this.content;
            this.setDataFromCacahe = '';

            result = RegxHelper.removeNotThai(result);
            result = RegxHelper.removeEmoji(result);
            result = RegxHelper.removeSymbol(result);
            if (this.isTextOnly) {
                result = RegxHelper.removeNumber(result);
            }
            if ((this.selectType == 'NRIC'|| (this.setDataFromCache && this.setDataFromCache.value == 'NRIC')) && this.isShowNo) {
                result = this.onNricFormat();
            }

            // if (this.selectType == 'Passport' || this.selectType == 'Passport' || this.selectType == '护照') {
            //     if (result.charAt(0) !== result.charAt(0).toUpperCase()) result = ''
            // }

            this.content = result;
            this.validateInput();
            this.$emit('update:inputValue', result);
        },
        onNricFormat: function() {
            let input = Util.isEmptyStr(this.content) ? '' : this.content;
            input = RegxHelper.removeEmoji(input);
            input = RegxHelper.removeNotNumber(input);
            input = RegxHelper.removeNotThai(input);
            let nric = input;
            if (!Util.isEmptyStr(this.delimeter)) {
                let n1;
                n1 = input.replace(/(\d{6})(\d{2})(\d{4})/, '$1-$2-$3');
                nric = n1;
            }
            return nric;
        },
        onFocus: function(focus) {
            this.focusText = focus;
        },
    },
}
</script>
<style lang="scss" scoped>
   @import "@/style/Input/Input.scss";
</style>
